module.exports = __webpack_public_path__ + "static/media/weather.88890b5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/weather.png
// module id = 477
// module chunks = 0